import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
    today: number = Date.now();
    appVersion: string = environment.appVersion;

    constructor(private readonly router: Router) {}
    navigation(route: string) {
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }
}
